// extracted by mini-css-extract-plugin
export var form = "_fg-0";